import API from "../api"

const AllocationService = {
  getAllocation: () => API.get(`org/allocation`),
};

export default AllocationService;
